import { z } from "zod";
// Schema for course reviews
export const ReviewSchema = z.object({
    id: z.number().int(),
    user_id: z.number().int(),
    user_uid: z.string(),
    course_id: z.number().int(),
    rating: z.number().min(1).max(5),
    comment: z.string().nullable(),
    is_approved: z.boolean().default(true),
    created_at: z.date(),
    updated_at: z.date(),
    // Denormalized user info for display
    user_name: z.string().nullable().optional(),
    user_avatar: z.string().nullable().optional(),
    // Denormalized course info for display
    course_name: z.string().nullable().optional(),
});
// Schema for creating a review
export const ReviewPayloadSchema = z.object({
    course_id: z.number().int(),
    rating: z.number().min(1).max(5),
    comment: z.string().nullable().optional(),
});
// Schema for updating a review
export const ReviewUpdateSchema = z.object({
    rating: z.number().min(1).max(5).optional(),
    comment: z.string().nullable().optional(),
    is_approved: z.boolean().optional(),
});
// Schema for review statistics
export const ReviewStatsSchema = z.object({
    total_reviews: z.number().min(0),
    average_rating: z.number().min(0).max(5),
    rating_distribution: z.object({
        "1": z.number().min(0),
        "2": z.number().min(0),
        "3": z.number().min(0),
        "4": z.number().min(0),
        "5": z.number().min(0),
    }),
});
